import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const VisaIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/visa.svg" style={style} />;
